import { useMutation, useQueryClient } from '@tanstack/react-query';
import { t } from 'i18next';
import { useHandlers } from '../../../context/page-context';
import { handleCustomerGroupTableDeleteError } from '../handle-errors';
import { QK_GET_CUSTOMER_GROUPS } from './use-customer-groups';
import { useCustomerGroupsApi } from './use-customer-groups-api';

export function useDeleteCustomerGroup(name: string) {
  const { navigationHandler, notificationHandler } = useHandlers();
  const { customerGroupsApi } = useCustomerGroupsApi();
  const queryClient = useQueryClient();

  // Don't use Optimistic Update as it deletes the data and causes the page to rerender, resulting
  // in an error. Keep callbacks in hook as unmounting modals can remove the component callbacks.
  return useMutation({
    mutationFn: (slug: string) => customerGroupsApi.group(slug).delete(),
    onError: (err) => handleCustomerGroupTableDeleteError(err, notificationHandler, name),
    onSuccess: () => {
      navigationHandler.navigate('/customers/groups');
      queryClient.invalidateQueries({
        queryKey: QK_GET_CUSTOMER_GROUPS(),
        // mark it as stale and don't refetch
        refetchType: 'none',
      });
      notificationHandler.success(
        t(
          'features:customer_group.components.delete_customer_group_modal.status.success.delete_succeeded',
          { name: name },
        ),
      );
    },
  });
}
